import { initializeApp } from 'firebase/app'

// todo externalize
const firebaseConfig = {
  apiKey: 'AIzaSyCdzN7i3yrxL0riemIZTzqa7zIuH6LUBgU',
  authDomain: 'stammgast-gov.firebaseapp.com',
  databaseURL: 'https://stammgast-gov.firebaseio.com',
  projectId: 'stammgast-gov',
  storageBucket: 'stammgast-gov.appspot.com',
  messagingSenderId: '893903084180',
  appId: '1:893903084180:web:4040027e50900db71c3281'
}

export default {
  init () {
    initializeApp(firebaseConfig)
  }
}
